import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualCallReport extends React.Component {
  constructor(props) {
    super(props);

    const usersOptions = reactLocalStorage.getObject(Constants.Model).user.options;
    // Find the logged-in user's name using their ID
    this.UserName = usersOptions.find((option) => option.id === parseInt(this.props.filters.selectedIds[0])).name;

   this.state = {totalSums: 0}
  }

  componentDidMount() {
    // Fetch data from the API
    IndividualSalesReportAPI.getIndividualCall(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (receivedData) => {
      const totalSums = receivedData.reduce((acc , {sum})=>acc+=sum,0);
      this.setState({totalSums:totalSums}) 
  }
  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
const {totalSums} = this.state;

    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Call Report</h2>
          <hr />
          <div className="row mt-3 p-2">
          <Table striped bordered hover className="col-md-5">
            <thead>
              <tr>
                <th>Sales Executive</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {/* Display the logged-in user's name and their total calls */}
              <tr>
                <td>{this.UserName}</td>
                <td>{totalSums}</td>
              </tr>
              {/* Display the total sum */}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSums}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-5">
              {/* Pass only progressSums and progressOptions to ChartComponent */}
              <ChartComponent DirectSum={totalSums} DirectUser={this.UserName} type={"pie"}/>
          </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(IndividualCallReport);
